import React from 'react';
import Head from 'next/head';
import cx from 'classnames';
import Image from 'next/image';
import styles from './error.module.scss';
import main400Image from '../public/images/error/400.main.png';
import background400Image from '../public/images/error/400.background.png';
import main500Image from '../public/images/error/500.main.png';
import background500Image from '../public/images/error/500.background.png';
import logo from '../public/images/logo.png';

import { generateBlurDataURL } from '../helpers/image-placeholders';

type Props = {
  errorCode?: number;
};

const ErrorPage = ({ errorCode }: Props) => {
  let backgroundImage = background400Image;
  let mainImage = main400Image;
  let description = 'Sorry, something went wrong attending your request.';

  switch (errorCode) {
    case 200: // Also display a 404 if someone requests /_error explicitly
    case 404:
      description = 'Sorry, we can’t find the page you are looking for.';
      break;
    case 500:
      backgroundImage = background500Image;
      mainImage = main500Image;
      description =
        'Sorry, the server encountered an internal error and was unable to complete your request.';
      break;
    default:
  }

  return (
    <>
      <Head>
        <title>
          Equinox+
          {` | Error ${errorCode || ''}`}
        </title>
        <meta name="Description" content="Error page." />
      </Head>
      <div className={cx(styles.error, 'dark')}>
        <div>
          <Image
            placeholder="blur"
            alt="Background Error"
            src={backgroundImage}
            layout="fill"
            objectFit="cover"
            quality={100}
            blurDataURL={generateBlurDataURL(backgroundImage)}
          />
          <div className={styles['error__background-layer']} />
        </div>
        <div className={cx('container', styles.error__container)}>
          <a href="/" className={styles.error__logo}>
            <Image
              src={logo}
              alt="Equinoxplus Logo"
              layout="responsive"
              width={180}
              height={20}
            />
          </a>
          <h1 className={styles.error__title}>{errorCode}</h1>
          <p className={styles.error__description}>{description}</p>
          <div className={styles['error__main-image']}>
            <Image
              placeholder="blur"
              src={mainImage}
              alt="Error Cover"
              layout="responsive"
              width={1000}
              height={500}
              blurDataURL={generateBlurDataURL(mainImage)}
            />
          </div>
        </div>
      </div>
    </>
  );
};

ErrorPage.defaultProps = {
  errorCode: null
};

export default ErrorPage;
